import { createAction } from '@reduxjs/toolkit';
export const UPDATE_ANALYTIC_TEAM = 'UPDATE_ANALYTIC_TEAM';
export const updateAnalyticTeamAction = createAction(UPDATE_ANALYTIC_TEAM);